<template>
  <div class="vue-modal modal--previous" id="cc-1919-modal">
    <button class="button--toggle" v-on:click="$emit('toggle-modal')">
      <span class="button--toggle__image">
        <img src="https://cdn.concertconsult.co.uk/1919-survey/arrow_white.svg" alt="arrow">
      </span>
      Back to this quarter
    </button>

    <button class="button--modal-close" v-on:click="$emit('close-modal')">
      <span class='svg-container modal-close'><Close/></span>
      Close
    </button>

    <div class="modal__container" id="cc-1919-mdlcntr">
      <resultsPrevious
        v-if="Object.keys(apiData).length > 0"
        :apiData="apiData"
      >  
      </resultsPrevious>
      <div v-else>
        <h1 class="headline">Last quarter's results</h1>
        <p><strong>This quarter's question is the first question</strong></p>
        <p>Check back next quarter to see the results</p>
      </div>
    </div>
  </div>
</template>

<script>

import resultsPrevious from './ResultsPrevious.vue'

import Close from '../assets/close.svg'

export default {
  name: 'QuestionModalPrevious',
  components: {
    resultsPrevious,
    Close
  },
  props: {
    apiData: Object
  },
  mounted: function () {
    let content = document.getElementById('cc-1919-mdlcntr');
    let modal = document.getElementById('cc-1919-modal');
    if ( content.clientHeight > modal.clientHeight ) {
      modal.style.height = content.clientHeight + 40 + "px";
    }
  }
}
</script>